import React from "react";
import LegalPage from "./LegalPage";

const sections = [
  {
    title: "1. Кто даёт согласие",
    paragraphs: ["Настоящее согласие даёт родитель или законный представитель ребёнка, данные которого размещаются или передаются через сайт и сервис Fresh Casting."],
  },
  {
    title: "2. Кому даётся согласие",
    paragraphs: ["Согласие даётся Индивидуальному предпринимателю СКОРЯБКИНОЙ АЛЕКСАНДРЕ ВАЛЕРЬЕВНЕ, ИНН 781602232900, ОГРНИП 325784700307756."],
  },
  {
    title: "3. Какие данные ребёнка могут обрабатываться",
    paragraphs: ["Могут обрабатываться имя, фамилия, возраст и/или дата рождения, город, рост, фотографии, видео, параметры анкеты, опыт, ссылки и иные данные, добровольно предоставленные родителем или законным представителем при создании и ведении анкеты ребёнка."],
  },
  {
    title: "4. Цели обработки",
    paragraphs: ["Данные ребёнка обрабатываются для создания анкеты, хранения профиля, показа анкеты на сайте, рассмотрения ребёнка для кастинг-предложений, связи по кастинг-предложениям и передачи данных организаторам кастингов при наличии отдельного согласия родителей или законных представителей."],
  },
  {
    title: "5. Действия с данными",
    paragraphs: ["Оператор вправе осуществлять сбор, запись, систематизацию, накопление, хранение, уточнение, использование, передачу в рамках указанных целей, обезличивание, блокирование и удаление персональных данных в соответствии с законодательством РФ."],
  },
  {
    title: "6. Отзыв согласия",
    paragraphs: ["Согласие может быть отозвано родителем или законным представителем путём направления обращения оператору. После получения отзыва обработка данных прекращается в пределах, предусмотренных законодательством РФ."],
  },
  {
    title: "7. Контакт для обращений",
    paragraphs: ["По вопросам обработки данных и отзыва согласия можно обратиться через Telegram: t.me/kastingi_deti."],
  },
];

const ParentConsentPage = () => <LegalPage title="Согласие родителя / законного представителя" subtitle="На обработку персональных данных ребёнка для размещения анкеты и участия в кастинг-предложениях." sections={sections} />;

export default ParentConsentPage;
